// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"229":"afc3cf69","562":"36c81a98","946":"2b3ccfe2"}[chunkId] + ".css";
};